import React, { useEffect, useState } from "react";
import { createPortal } from "react-dom";
import Icon from "../Icon/Icon";
import s from "./Toast.module.scss";

/**
 * Conferme brevi ("Link copiato", "Salvato") che non meritano un modale.
 * Si chiamano da qualunque punto con toast("testo") o toast.error("testo").
 */
const EVENT = "pr:toast";

export function toast(message, { type = "ok", duration = 3200, action } = {}) {
  window.dispatchEvent(new CustomEvent(EVENT, { detail: { id: Math.random().toString(36).slice(2), message, type, duration, action } }));
}
toast.error = (message, opts = {}) => toast(message, { ...opts, type: "error", duration: opts.duration || 5200 });

export function Toaster() {
  const [items, setItems] = useState([]);
  useEffect(() => {
    const on = (e) => {
      const t = e.detail;
      setItems((list) => [...list.slice(-3), t]);
      setTimeout(() => setItems((list) => list.filter((x) => x.id !== t.id)), t.duration);
    };
    window.addEventListener(EVENT, on);
    return () => window.removeEventListener(EVENT, on);
  }, []);
  return createPortal(
    <div className={s.stack} aria-live="polite">
      {items.map((t) => (
        <div key={t.id} className={`${s.toast} ${t.type === "error" ? s.error : ""}`}>
          <Icon name={t.type === "error" ? "info" : "check"} size={18} strokeWidth={2.2} />
          <span>{t.message}</span>
          {t.action && (
            <button
              type="button"
              className={s.action}
              onClick={() => {
                t.action.onClick();
                setItems((list) => list.filter((x) => x.id !== t.id));
              }}
            >
              {t.action.label}
            </button>
          )}
        </div>
      ))}
    </div>,
    document.body,
  );
}
